const { createLedgerRows } = require('./ledger-export')

// returns the data to be used in tests
async function exportLedgerData (state, ledgers) {
  return createLedgerRows(state, ledgers)
}

module.exports = { exportLedgerData }
